import { render, staticRenderFns } from "./Life.vue?vue&type=template&id=5f587e7d&scoped=true"
import script from "./Life.vue?vue&type=script&lang=js"
export * from "./Life.vue?vue&type=script&lang=js"
import style0 from "./Life.vue?vue&type=style&index=0&id=5f587e7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f587e7d",
  null
  
)

export default component.exports